import { render } from "./ModalInc.vue?vue&type=template&id=41b145d6"
import script from "./ModalInc.vue?vue&type=script&lang=js"
export * from "./ModalInc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__